/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tasks_Panel_CountInputs */

const en_tasks_panel_count = /** @type {(inputs: Tasks_Panel_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} active`)
};

const fr_tasks_panel_count = /** @type {(inputs: Tasks_Panel_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} active(s)`)
};

const ms_sg2_tasks_panel_count = /** @type {(inputs: Tasks_Panel_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} aktif`)
};

/**
* | output |
* | --- |
* | "{count} active" |
*
* @param {Tasks_Panel_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_count = /** @type {((inputs: Tasks_Panel_CountInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_CountInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_count(inputs)
	if (locale === "fr") return fr_tasks_panel_count(inputs)
	return ms_sg2_tasks_panel_count(inputs)
});